import React from "react";
import Select from "react-select";
import { SELECT_STYLES } from "../../config";
import _ from "../../i18n";
import styles from "./NewsletterModal.module.scss";

const TemplateSelect = ({
  value,
  onChange,
  onPreview,
  templatesList,
  templatesLoading,
  templatesHasMore,
  templatesPage,
  loadTemplates,
  searchTemplates,
}) => {
  const selected = templatesList.find((t) => t.value === value) ?? null;

  return (
    <div className={styles.template_cell}>
      <Select
        styles={{
          ...SELECT_STYLES,
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        options={templatesList}
        isClearable={true}
        isSearchable={true}
        isLoading={templatesLoading}
        filterOption={() => true}
        placeholder="Choisir un template..."
        value={selected}
        onChange={(e) => onChange(e ? e.value : null)}
        onMenuScrollToBottom={() => {
          if (templatesHasMore && !templatesLoading) {
            loadTemplates(templatesPage + 1);
          }
        }}
        onInputChange={(search, { action }) => {
          if (action === "input-change") {
            searchTemplates(search);
          }
        }}
      />

      {selected && (
        <button className={styles.voir_btn} onClick={() => onPreview(value)}>
          <i className="icon-ttp-eye" />
          {_("preview")}
        </button>
      )}
    </div>
  );
};

export default TemplateSelect;
